import { DxButtonModule } from 'devextreme-angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InfoHeaderComponent } from './info-header.component';



@NgModule({
	declarations: [InfoHeaderComponent],
	exports: [InfoHeaderComponent],
	imports: [
		CommonModule,
		DxButtonModule
	]
})
export class InfoHeaderModule { }
